import { Link } from 'react-router-dom';

const AboutHero = () => {
  return (
    <section className="relative min-h-[600px] flex items-center">
      <div className="absolute inset-0 lg:w-3/5 bg-navy"></div>
      <div
        className="absolute inset-0 lg:left-[50%] bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/fc10912359cf933f58fe91ee629ee603.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-navy/20"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-20 w-full">
        <div className="lg:w-2/5">
          <p className="text-gold font-bold text-sm tracking-widest uppercase mb-4">ABOUT US</p>
          <h1 className="text-4xl lg:text-5xl font-extrabold text-white mb-6 leading-tight">
            Western Australia's Commercial Electrical Specialists
          </h1>
          <p className="text-gray-300 text-base leading-relaxed mb-4">
            NS Electrical WA is a licensed electrical contractor delivering precision electrical solutions for commercial properties across Western Australia.
          </p>
          <p className="text-gray-300 text-base leading-relaxed mb-4">
            Our team specialises in commercial fit-outs, switchboard installations, compliance testing, and preventative maintenance programs that keep businesses operating safely and efficiently.
          </p>
          <p className="text-gray-300 text-base leading-relaxed mb-8">
            With extensive experience serving property managers, builders, and business owners, we deliver reliable workmanship that meets Australian Standards and exceeds client expectations.
          </p>
          <Link
            to="/commercial-services"
            className="inline-flex items-center gap-2 bg-gold text-navy px-8 py-3 rounded-lg font-bold text-sm tracking-wider hover:bg-gold-light transition-all whitespace-nowrap cursor-pointer"
          >
            VIEW OUR SERVICES
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;